import { Home, CreditCard, ArrowDownUp, Settings } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { name: "Home",          icon: <Home className="w-5 h-5" />,          path: "/dashboard" },
    { name: "Card",          icon: <CreditCard className="w-5 h-5" />,    path: "/card" },
    { name: "Bank Transfer", icon: <ArrowDownUp className="w-5 h-5" />,   path: "/bank-transfer" },
    { name: "Settings",      icon: <Settings className="w-5 h-5" />,      path: "/settings" },
  ];

  return (
    <>
      {/* Sticky Bottom Nav – Stays at bottom of page content */}
      <nav className="sticky bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-40">
        <div className="flex justify-around items-center py-2">
          {navItems.map((item) => (
            <button
              key={item.name}
              onClick={() => navigate(item.path)}
              className={`
                flex flex-col items-center gap-1 px-3 py-2 rounded-lg transition-all
                ${location.pathname === item.path ? "text-primary" : "text-gray-500 hover:text-primary"}
              `}
            >
              <div
                className={`
                  p-2 rounded-full transition-all
                  ${location.pathname === item.path ? "bg-primary/10" : "bg-transparent"}
                `}
              >
                {item.icon}
              </div>
              <span className="text-xs font-medium">{item.name}</span>
            </button>
          ))}
        </div>
      </nav>

      {/* Optional: Extra padding if needed (not required with sticky) */}
      {/* <div className="pb-20" /> */}
    </>
  );
}